import { render } from "./MajorTable.vue?vue&type=template&id=290cc47d"
import script from "./MajorTable.vue?vue&type=script&lang=js"
export * from "./MajorTable.vue?vue&type=script&lang=js"

import "./MajorTable.vue?vue&type=style&index=0&id=290cc47d&lang=css"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__